export default __webpack_public_path__ + "static/media/cppsolo.b3d451b0.jpg";